































import * as _ from 'lodash';
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import $ from 'jquery';
import StateBar from '@/components/mobile/basics/StateBar.vue';
import { Language, VisitorType } from '../../../types/Enum';

@Component({
  components: {
    StateBar,
  },
})
export default class HomeScreen extends Vue {
    private start: boolean = false;

    public mounted() {
    }
}
